import { logEvent } from 'utils/eventTracking';
import { FancyInformationMessage, OverlayPortal } from '@morressier/ts';
import { FeatureFlags } from 'config/featureFlags';

export const DelegateRejectModal = ({
  showRejectRequestModal,
  setShowRejectRequestModal,
  sessionId,
  eventId,
}: {
  showRejectRequestModal: boolean;
  setShowRejectRequestModal: (status: boolean) => void;
  sessionId: string;
  eventId: string;
}) => (
  <>
    {FeatureFlags.Enable_Delegate_To_Stage.isEnabled() && showRejectRequestModal && (
      <OverlayPortal color="#424d5d69">
        <FancyInformationMessage
          icon="none"
          title="The Host is not receiving more people on Stage."
          subline="Keep watching and try again at the next opportunity."
          actions={[
            {
              method: () => {
                setShowRejectRequestModal(false);
                logEvent('JOIN_STAGE_INVITATION_REJECTION_RECEIVED', {
                  session_id: sessionId,
                  event_id: eventId,
                });
              },
              text: 'Got it',
              color: 'primary',
              styles: {},
            },
          ]}
          style={{
            padding: '1rem',
            backgroundColor: '#FFFFFF',
            borderRadius: '8px',
            height: '256px',
            width: '685px',
          }}
        />
      </OverlayPortal>
    )}
  </>
);
